/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconArrowDown = ({
  fill = "none",
  stroke = "currentColor",
  weight = "normal",
  ...props
}: Props) => (
  <svg
    viewBox="0 0 24 24"
    css={css`
      * {
        vector-effect: non-scaling-stroke;
      }
      overflow: visible;
      height: 24px;
    `}
    {...props}
  >
    <path
      fill={fill}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={weight === "normal" ? 1.5 : 1}
      d="M23.25 7.311 12.53 18.03a.749.749 0 0 1-1.059.001l-.001-.001L.75 7.311"
    />
  </svg>
);
